import ProductSlateActionsContainer from './ProductSlateActionsContainer'

export default ProductSlateActionsContainer
